import React from 'react';

import { useSelector } from 'react-redux';

import {
    Button,
    Glyphicon,
    SubHeading,
} from 'reaxl';
import { DelayedImpressionObserver, sendClick, sendImpressions } from 'reaxl-analytics';
import { ndsInsuranceSponsorCtaClick } from 'reaxl-analytics-handlers';

import inventoryDuck from '@/ducks/inventoryDuck.js';

const SponsoredInsuranceContainer = React.memo(({
    externalHost,
    id: listingId,
    logoMap,
    sponsorName,
    vin,
    vinParam,
    zip,
    zipParam,
}) => {

    const inventory = useSelector(inventoryDuck.selectors.selectHydratedInventory);
    const owner = inventory[listingId]?.owner;
    const ownerId = owner?.id;

    const eventData = {
        listingId,
        sponsor: sponsorName,
        ownerId,
        zip,
    };

    const handleImpression = () => {
        sendImpressions({ name: 'ndsInsuranceSponsorInviewImpression', data: { ...eventData } });
    };

    const buildHref = () => {
        let host = `${externalHost}&${vinParam}=${vin}`;

        if (zipParam && zip) {
            host += `&${zipParam}=${zip}`;
        }

        return host;
    };

    const ctaHref = buildHref();

    const handleCtaClick = (event) => {
        sendClick(ndsInsuranceSponsorCtaClick, event, { ...eventData });
    };

    return (
        <DelayedImpressionObserver
            key={`sponsored-insurance-container-${vin}`}
            onChange={handleImpression}
            delay={0}
            id="sponsored-insurance-container"
        >
            <div
                data-cmp="sponsored-insurance-container"
            >
                <div>
                    <SubHeading size={300}>
                        Car Insurance Made Simple
                    </SubHeading>
                    Discover how easy it is to find the right auto insurance coverage. Get a quote for this vehicle in under 5 minutes.
                </div>

                <div className="padding-top-3">

                    <img
                        height="20px"
                        src={`https://www.autotrader.com/cm-api/content/static/img/icon/logos/${logoMap[sponsorName?.toLowerCase()]}`}
                        alt={`${sponsorName} Logo`}
                        className="margin-right-2 margin-right-sm-3"
                    />

                    <Button
                        bsStyle="default"
                        bsSize="small"
                        className=""
                        onClick={handleCtaClick}
                        href={ctaHref}
                        target="_blank"
                    >
                        Get a Quote
                        <Glyphicon
                            glyph="offsite"
                            className="margin-left-1"
                        />
                    </Button>
                </div>

            </div>
        </DelayedImpressionObserver>
    );
}, (prevProps, nextProps) => prevProps.vin === nextProps.vin && prevProps.zip === nextProps.zip);

export default SponsoredInsuranceContainer;
